import usePlugin from 'plugin/base/hook/usePlugin';
import { virtualBraindateFeature } from 'plugin/virtual-braindate/setting/virtualBraindateSettings';

export default function useVirtualBraindate(): boolean {
  return usePlugin(virtualBraindateFeature);
}
